/**
 * Step 1: Import custom modal
 */
import {
	SupervisorOrderExpanded,
	SupervisorOrderReports,
	SupervisorChangeCoords,
	// <--HERE
} from './Supervisor';
import {
	UpdateOrderEvent,
	OrderDeleteAuditedOTD,
	// <--HERE
} from './Orders';
import {
	UserProfile,
	// <--HERE
} from './User';
import {
	CreateNewArticle,
	CreateNewPackge,
	// <--HERE
} from './Transactions';
import {
	ResumePayment,
	ResumePaycut,
	CreatePaymentLine,
	CreatePayment,
	CreateInvoicePayment,
	// <--HERE
} from './Billing';


/**
 * Step 2: Create modal key
 */
const authorizedModalKeys = {
	orderExpandedModal: 'orderExpandedModal',
	orderReportsModal: 'orderReportsModal',
	supervisorChangeCoords: 'supervisorChangeCoords',
	updateOrderEvent: 'updateOrderEvent',
	userProfile: 'userProfile',
	orderDeleteAuditedOTD: 'orderDeleteAuditedOTD',
	transactionNewArticle: 'transactionNewArticle',
	transactionNewPackage: 'transactionNewPackage',
	resumePaymentModal: 'resumePaymentModal',
	resumePaycutModal: 'resumePaycutModal',
	createPaymentLineModal: 'createPaymentLineModal',
	createPaymentModal: 'createPaymentModal',
	createInvoicePaymentModal: 'createInvoicePaymentModal',
	// <--HERE
};

/**
 * Step 3: Match modal key with React Node
 */
const authorizedModalComponents = {
	[authorizedModalKeys.orderExpandedModal]: SupervisorOrderExpanded,
	[authorizedModalKeys.orderReportsModal]: SupervisorOrderReports,
	[authorizedModalKeys.supervisorChangeCoords]: SupervisorChangeCoords,
	[authorizedModalKeys.updateOrderEvent]: UpdateOrderEvent,
	[authorizedModalKeys.userProfile]: UserProfile,
	[authorizedModalKeys.orderDeleteAuditedOTD]: OrderDeleteAuditedOTD,
	[authorizedModalKeys.transactionNewArticle]: CreateNewArticle,
	[authorizedModalKeys.transactionNewPackage]: CreateNewPackge,
	[authorizedModalKeys.resumePaymentModal]: ResumePayment,
	[authorizedModalKeys.resumePaycutModal]: ResumePaycut,
	[authorizedModalKeys.createPaymentLineModal]: CreatePaymentLine,
	[authorizedModalKeys.createPaymentModal]: CreatePayment,
	[authorizedModalKeys.createInvoicePaymentModal]: CreateInvoicePayment,
	// <--HERE
};

export default class ModalBuilderConfig {
	static getAuthorizedModalKeys() {
		return authorizedModalKeys;
	}

	static getAuthorizedModalReactNode(modalKey) {
		return authorizedModalComponents[modalKey];
	}
}
